// Auto-derived lightweight nav data. Keeps the large services/cities content
// files out of the shared client bundle (the header ships on every page).
export const NAV_SERVICES: Array<{ slug: string; name: string }> = [
  {
    "slug": "house-washing",
    "name": "House Washing"
  },
  {
    "slug": "roof-washing",
    "name": "Roof Washing"
  },
  {
    "slug": "paver-cleaning-sealing",
    "name": "Paver Cleaning & Sealing"
  },
  {
    "slug": "concrete-cleaning-sealing",
    "name": "Concrete & Driveway Cleaning"
  },
  {
    "slug": "driveway-cleaning",
    "name": "Driveway Cleaning"
  },
  {
    "slug": "sidewalk-cleaning",
    "name": "Sidewalk & Walkway Cleaning"
  },
  {
    "slug": "siding-cleaning",
    "name": "Siding Cleaning"
  },
  {
    "slug": "soft-washing",
    "name": "Soft Washing"
  },
  {
    "slug": "deck-patio-cleaning",
    "name": "Deck & Patio Cleaning"
  },
  {
    "slug": "patio-cleaning",
    "name": "Patio Cleaning"
  },
  {
    "slug": "composite-deck-cleaning",
    "name": "Composite & Trex Deck Cleaning"
  },
  {
    "slug": "rust-stain-removal",
    "name": "Rust & Stain Removal"
  },
  {
    "slug": "gutter-cleaning",
    "name": "Gutter Cleaning"
  },
  {
    "slug": "gutter-guards",
    "name": "Gutter Guards"
  },
  {
    "slug": "window-cleaning",
    "name": "Window Cleaning"
  },
  {
    "slug": "fence-cleaning",
    "name": "Fence Cleaning"
  },
  {
    "slug": "holiday-lighting",
    "name": "Holiday Lighting"
  },
  {
    "slug": "permanent-lighting",
    "name": "Permanent Outdoor Lighting"
  },
  {
    "slug": "commercial-pressure-washing",
    "name": "Commercial Pressure Washing"
  },
  {
    "slug": "agricultural-barn-washing",
    "name": "Barn & Agricultural Washing"
  },
  {
    "slug": "roof-rejuvenation",
    "name": "Roof Rejuvenation"
  }
];

export const NAV_CITIES: Array<{ slug: string; city: string }> = [
  {
    "slug": "pressure-washing-albany-ny",
    "city": "Albany"
  },
  {
    "slug": "pressure-washing-schenectady-ny",
    "city": "Schenectady"
  },
  {
    "slug": "pressure-washing-saratoga-springs-ny",
    "city": "Saratoga Springs"
  },
  {
    "slug": "pressure-washing-troy-ny",
    "city": "Troy"
  },
  {
    "slug": "pressure-washing-clifton-park-ny",
    "city": "Clifton Park"
  },
  {
    "slug": "pressure-washing-rensselaer-ny",
    "city": "Rensselaer"
  },
  {
    "slug": "pressure-washing-colonie-ny",
    "city": "Colonie"
  },
  {
    "slug": "pressure-washing-latham-ny",
    "city": "Latham"
  },
  {
    "slug": "pressure-washing-guilderland-ny",
    "city": "Guilderland"
  },
  {
    "slug": "pressure-washing-delmar-ny",
    "city": "Delmar"
  },
  {
    "slug": "pressure-washing-niskayuna-ny",
    "city": "Niskayuna"
  },
  {
    "slug": "pressure-washing-ballston-spa-ny",
    "city": "Ballston Spa"
  },
  {
    "slug": "pressure-washing-altamont-ny",
    "city": "Altamont"
  },
  {
    "slug": "pressure-washing-bethlehem-ny",
    "city": "Bethlehem"
  },
  {
    "slug": "pressure-washing-loudonville-ny",
    "city": "Loudonville"
  },
  {
    "slug": "pressure-washing-menands-ny",
    "city": "Menands"
  },
  {
    "slug": "pressure-washing-halfmoon-ny",
    "city": "Halfmoon"
  },
  {
    "slug": "pressure-washing-east-greenbush-ny",
    "city": "East Greenbush"
  },
  {
    "slug": "pressure-washing-glenmont-ny",
    "city": "Glenmont"
  },
  {
    "slug": "pressure-washing-ravena-ny",
    "city": "Ravena"
  }
];
